import { type App, type InjectionKey, inject } from 'vue'

import { ApiRequests } from './api-requests'

const API_REQUESTS_ADDON_SYMBOL: InjectionKey<ApiRequests> = Symbol('ApiRequests')

export function createApiRequestsPlugin(api: ApiRequests) {
    return {
        install(app: App) {
            app.provide(API_REQUESTS_ADDON_SYMBOL, api)
        },
    }
}

export function useAPI(): ApiRequests {
    const api = inject(API_REQUESTS_ADDON_SYMBOL)
    if (!api) {
        throw new Error('No API class provided in Vue app.')
    }
    return api
}
